import { useMemo } from "react";
import { WHEEL_MONTHS, CUR_YEAR, CUR_MONTH } from "./shared";

export function Arshjul({ year, meetings, points, onSelect }) {
  const byMonth = useMemo(() => {
    const map = {};
    meetings.forEach((m) => {
      const mi = new Date(m.date).getMonth();
      (map[mi] = map[mi] || []).push(m);
    });
    return map;
  }, [meetings]);
  const pointsByMonth = useMemo(() => {
    const map = {};
    (points || []).forEach((p) => {
      const mi = Math.max(1, Math.min(12, p.month)) - 1;
      (map[mi] = map[mi] || []).push(p);
    });
    return map;
  }, [points]);
  const size = 300, R = 120, c = size / 2;
  return (
    <div className="relative mx-auto" style={{ width: size, height: size }} data-testid="arshjul">
      <div className="absolute inset-7 rounded-full border-2 border-dashed border-border/70" />
      <div className="absolute left-1/2 top-1/2 grid h-24 w-24 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-primary text-center text-primary-foreground shadow-lg">
        <div>
          <p className="text-[9px] uppercase tracking-[0.2em] opacity-80">Årshjul</p>
          <p className="font-headings text-2xl font-extrabold leading-none">{year}</p>
          <p className="mt-0.5 text-[10px] opacity-80">{meetings.length} møter</p>
        </div>
      </div>
      {WHEEL_MONTHS.map((mo, i) => {
        const ang = (i / 12) * 2 * Math.PI - Math.PI / 2;
        const x = c + R * Math.cos(ang);
        const y = c + R * Math.sin(ang);
        const list = byMonth[i] || [];
        const pts = pointsByMonth[i] || [];
        const has = list.length > 0;
        const hasPoint = pts.length > 0;
        const allSigned = has && list.every((m) => m.status === "signert");
        const isCur = year === CUR_YEAR && i === CUR_MONTH - 1;
        const title = [...list.map((m) => m.title), ...pts.map((p) => `• ${p.title}`)].join("\n");
        return (
          <button
            key={i}
            data-testid={`arshjul-month-${i}`}
            disabled={!has}
            onClick={() => has && onSelect(list[0])}
            title={title}
            style={{ left: x, top: y, transform: "translate(-50%, -50%)" }}
            className={`absolute grid h-11 w-11 place-items-center rounded-full border text-[11px] font-bold transition-colors ${
              has
                ? "cursor-pointer border-primary/40 bg-primary/15 text-primary hover:bg-primary/25"
                : hasPoint
                ? "cursor-default border-blue-500/40 bg-blue-500/10 text-blue-600 dark:text-blue-400"
                : "cursor-default border-border bg-card text-muted-foreground/60"
            } ${isCur ? "ring-2 ring-primary ring-offset-2 ring-offset-background" : ""}`}
          >
            {mo}
            {has ? (
              <span className="absolute -right-1 -top-1 grid h-4 w-4 place-items-center rounded-full bg-primary text-[9px] font-bold text-primary-foreground">{list.length}</span>
            ) : null}
            {has ? (
              <span
                data-testid={`arshjul-sign-${i}`}
                title={allSigned ? "Alle protokoller signert" : "Mangler signaturer"}
                className={`absolute -bottom-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 rounded-full border-2 border-background ${allSigned ? "bg-emerald-500" : "bg-amber-500"}`}
              />
            ) : null}
            {hasPoint ? (
              <span
                data-testid={`arshjul-point-${i}`}
                title={pts.map((p) => p.title).join(", ")}
                className="absolute -left-1 -top-1 h-2.5 w-2.5 rounded-full border-2 border-background bg-blue-500"
              />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
